import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useStore } from '../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IDetailProps } from '../../models/forms/IForm';
import { ITrayVM } from '../../models/response/ITrayResponse';
import { formatMessage } from '../../translations/format-message';

const ActiveTrayDetails = (props: IDetailProps) => {
  const { trayManagementStore } = useStore();
  const { GetTrayByIdService, trayDetails } = trayManagementStore;
  const trayDetail: ITrayVM = trayDetails;

  useEffect(() => {
    if (props.selectedRowId > 0) {
      GetTrayByIdService(
        Number(getTenantIdFromLocalStorage()),
        props.selectedRowId
      );
    }
  }, [props.selectedRowId]);

  return (
    <>
      <div className="px-4 py-3">
        <h4 className="pb-3">{formatMessage('order_details')}</h4>
        <div className="row g-2">
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'tray_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.TrayId}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'customer_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.CustomerId}</h3>
            </div>
          </div>
          <div className="col-12">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'end_user_name'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.EndUserName || '--'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'end_user_order_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">
                {trayDetail.EndUserOrderId || '--'}
              </h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'order_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.OrderId || '--'}</h3>
            </div>
          </div>
          <div className="col-12">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'sub_contractor'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.SubContractor || '--'}</h3>
            </div>
          </div>
          <div className="col-12">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'sub_contractor_name'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">
                {trayDetail.SubContractorName || '--'}
              </h3>
            </div>
          </div>
          <div className="col-12">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'katashiki_1'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.Katashiki1 || '--'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'katashiki_2'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.Katashiki2 || '--'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'kishu'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.Kishu || '--'}</h3>
            </div>
          </div>
        </div>
      </div>
      <hr className="hr-border mt-3" />
      <div className="px-4">
        <h4 className="pb-3 mt-0">{formatMessage('product_details')}</h4>
        <div className="row g-2">
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'product_id'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.ProductName || '--'}</h3>
            </div>
          </div>
          {/*   <div className="col-12">
                        <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-between mb-2">
              <p className="title_sidebar">
                <FormattedMessage id={'katashiki'} />{' '}
              </p>
               <h3 className="mt-1 mb-0">{trayDetail.Katashiki || 'N/A'}</h3>
            </div>
          </div> */}
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'process_name'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.ProcessName || '--'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'quantity'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.Quantity || '--'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'invoice_number'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">{trayDetail.InvoiceNumber || '--'}</h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'quantity_unit_name'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">
                {trayDetail.QuantityUnitName || '--'}
              </h3>
            </div>
          </div>
          <div className="col-6">
            <div className="">
              <p className="title_sidebar">
                <FormattedMessage id={'missing_parts'} />{' '}
              </p>
              <h3 className="mt-1 mb-0">
                <div className="badge btn-danger">
                  {trayDetail.MissingParts || '--'}
                </div>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <hr className="hr-border mt-3" />
      <div className="px-4">
        <h4 className="mt-0">{formatMessage('comment')}</h4>
      </div>
      <div className="product-comment  mb-3">
        <div className="px-4 py-3">
          <div className="row g-2">
            <div>
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_1'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment1 || '--'}
                </h3>
              </div>
            </div>
            <div>
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_2'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment2 || '--'}
                </h3>
              </div>
            </div>
            <div className="col-12">
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_3'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment3 || '--'}
                </h3>
              </div>
            </div>
            <div>
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_4'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment4 || '--'}
                </h3>
              </div>
            </div>
            <div>
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_5'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment5 || '--'}
                </h3>
              </div>
            </div>
            <div>
              <p className="title_sidebar">
                <FormattedMessage id={'product_comment_6'} />{' '}
              </p>
              <div className="p-2 rounded comment-box mt-1">
                <h3 className="mt-1 mb-0">
                  {trayDetail.ProductComment6 || '--'}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4">
        <h4 className="pb-3 mt-0">{formatMessage('due_dates')}</h4>
        <div className="row g-2">
          <ul className="customer_due_date">
            <li className="">
              <small className="title_sidebar">
                <FormattedMessage id={'customer_due_date'} />{' '}
              </small>
              <h3 className="mt-1 mb-0">
                {trayDetail.CustomerDueDate || '--'}
              </h3>
            </li>

            {/* <li className="">
              <small className="title_sidebar">
                <FormattedMessage id={'planned_due_dates'} />{' '}
              </small>
              <h3 className="mt-1 mb-0">{trayDetail.PlanedDueDate || 'N/A'}</h3>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default observer(ActiveTrayDetails);
